module.exports = __webpack_public_path__ + "static/media/433483895_327834210274629_7888461705106896052_n.530edfc2.jpg";